import envConfig from '../config';
import { encodeDES, getSign } from "./encryptTool";


const requerstLog = true; //错误打印
const pointUrl = envConfig.BASE_URL || "";

console.log("env: ", envConfig.ENV_TYPE);

const falseResult = { code: -10, message: '网络不好请稍后重试' };

const loadingUtil = {
  show: () => { },
  close: () => { }
  // show: () => Taro.showLoading({ title: "加载中", mask: true }),
  // close: () => Taro.hideLoading()
}

const request = async (options) => {
  const {
    header,
    data = "",
    timeout = 20000,
    method = 'POST',
    showToast = false,
    closeLoading = false,
    ...opt
  } = options;

  const date = new Date().valueOf()
  const additionalHeader = (method === 'POST' || method === 'PUT')
    && {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=UTF-8',
    nonce: '123456',
    timestamp: date,
    sysid: '701',
    sign: getSign(data, date)
  };

  !closeLoading && loadingUtil.show();

  const resp = await Promise.race([
    fetch(opt.url, {
      headers: {
        ...(additionalHeader || {}),
        ...(header || {}),
      },
      body: encodeURIComponent(encodeDES(data)),
      method,
      timeout,
      ...opt,
    }).catch((_e) => undefined),
    new Promise((resolve) =>
      setTimeout(resolve, options.timeout || 20000),
    ),
  ]);

  if (resp) {
    if (resp.status !== 200) {
      //ReduxStore.dispatch(actions.logout());
      !options.closeLoading && loadingUtil.close();
      requerstLog && console.warn(`Request status ${resp.status}: `, opt.url);
      return falseResult;
    }
    const text = await resp.text();
    let json;

    try {
      json = JSON.parse(text);
    } catch (e) {
      requerstLog && console.warn('RESP failed to parse: ', text);
      throw e;
    }

    if (requerstLog && envConfig.ENV_TYPE === "test") {
      // 需要查看其它参数用 flipper 工具
      console.log("┏━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
      console.log("┃ url: ", resp.url);
      console.log("┃ body: ", options.data);
      console.log("┃ result: ", json);
      console.log("┗━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━");
    }

    return json;
  } else {
    !options.closeLoading && loadingUtil.close();
    requerstLog && console.warn('Request timeout: ', opt.url);
    return falseResult;
  }
}

export function get(url, body, options = { url: "" }) {
  const { url: _, ...opt } = options;
  return request({
    url: (pointUrl + url),
    data: jsonToGetStr(body),
    method: 'GET',
    ...opt,
  });
}


export function post(url, body, options = { url: "" }) {
  const { url: _, ...opt } = options;
  return request({
    url: (pointUrl + url),
    data: JSON.stringify(body),
    method: 'POST',
    ...opt,
  });
}

const jsonToGetStr = (data) => {
  return Object.keys(data).map(
    key => `${key}=${encodeURIComponent(data[key])}`
  ).join('&');
}